import { render, staticRenderFns } from "./MagnitudeScatterChart.vue?vue&type=template&id=1ce12716"
import script from "./MagnitudeScatterChart.vue?vue&type=script&lang=js"
export * from "./MagnitudeScatterChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports